import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { T } from "@/lib/i18n";
import { Button } from "@/components/ui/button";
import { LogOut, LayoutGrid, Users } from "lucide-react";

export const Navbar = () => {
  const { user, logout, lang, changeLang } = useAuth();
  const t = T[lang];
  const navigate = useNavigate();

  return (
    <header
      data-testid="nav-header"
      className="sticky top-0 z-40 bg-[#1a2e4a]/95 backdrop-blur-md border-b border-[#2c4366]"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 h-16 flex items-center justify-between gap-3">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-3 min-w-0">
          <img src="/brand/logo.png" alt="Dual Study Abroad" className="h-10 w-10 object-contain shrink-0" />
          <div className="hidden sm:block min-w-0">
            <div className="font-display font-extrabold text-white text-sm leading-tight truncate">
              {t.appName}
            </div>
            <div className="text-[10px] text-[#9db4d6] leading-tight truncate">Yurtdışı Eğitim Danışmanlık</div>
          </div>
        </Link>

        <div className="flex items-center gap-2 sm:gap-3">
          <div className="flex items-center rounded-full border border-[#2c4366] overflow-hidden text-xs">
            {["tr", "en"].map((l) => (
              <button
                key={l}
                data-testid={`lang-toggle-${l}`}
                onClick={() => changeLang(l)}
                className={`px-3 py-1.5 font-semibold transition-colors ${
                  lang === l ? "bg-[#c0392b] text-white" : "text-[#9db4d6] hover:text-white"
                }`}
              >
                {l.toUpperCase()}
              </button>
            ))}
          </div>

          {user ? (
            <>
              <Button
                data-testid="nav-dashboard-btn"
                variant="ghost"
                className="text-white hover:bg-[#254066] hover:text-white h-9 px-3"
                onClick={() => navigate("/dashboard")}
              >
                <LayoutGrid className="h-4 w-4 sm:mr-2" />
                <span className="hidden sm:inline">{t.dashboard}</span>
              </Button>
              {user.role === "admin" && (
                <Button data-testid="nav-admin-btn" variant="ghost" className="text-white hover:bg-[#254066] hover:text-white h-9 px-3" onClick={() => navigate("/admin")}>
                  <Users className="h-4 w-4 sm:mr-2" /><span className="hidden sm:inline">{t.adminPanel}</span>
                </Button>
              )}
              <Button
                data-testid="nav-logout-btn"
                variant="ghost"
                className="text-white hover:bg-[#254066] hover:text-white h-9 px-3"
                onClick={() => {
                  logout();
                  navigate("/");
                }}
              >
                <LogOut className="h-4 w-4" />
              </Button>
            </>
          ) : (
            <Button
              data-testid="nav-login-btn"
              className="bg-[#c0392b] hover:bg-[#a93226] text-white h-9"
              onClick={() => navigate("/auth")}
            >
              {t.login}
            </Button>
          )}
        </div>
      </div>
    </header>
  );
};
